import { useMemo } from "react";
import { WEBPAGE_CUSTOMIZATION_CONFIG } from "./Customization.constants";

export const useWebpageCustomizationConfig = () => {
  return useMemo(
    () =>
      WEBPAGE_CUSTOMIZATION_CONFIG.map((section) => ({
        ...section,
        subSectionConfig: section.subSectionConfig,
      })),
    []
  );
};
